import { IntegrationChannelType, IntegrationType } from 'generated/graphql';
import useGetIntegrationsFormData from 'v2/core/repository/edge-server/integrations/useGetIntegrationsFormData';

interface IsIntegrationDescriptionRequired {
  channelType: IntegrationChannelType;
  integrationType: IntegrationType;
}

export const useIsIntegrationDescriptionRequired = ({
  channelType,
  integrationType,
}: IsIntegrationDescriptionRequired): boolean => {
  const { data: integrationsFormData } = useGetIntegrationsFormData({
    fetchPolicy: 'cache-first', // We already have data in cache, so we can use cache-first here.
  });

  if (integrationType !== IntegrationType.Feedback) {
    return false;
  }

  const integrationForm = integrationsFormData?.find(
    (form) =>
      form.channel.type === channelType &&
      form.integrationType === integrationType,
  );

  return integrationForm?.isContextual ?? false;
};
